import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-grid p-m-2" }
const _hoisted_2 = { class: "p-col-12 p-md-6 p-lg-3" }
const _hoisted_3 = { for: "showRightConfigMenu" }
const _hoisted_4 = { class: "p-col-12 p-md-6 p-lg-3" }
const _hoisted_5 = { for: "showLegendButton" }
const _hoisted_6 = { class: "p-col-12 p-md-6 p-lg-3" }
const _hoisted_7 = { for: "showDistanceCalculator" }
const _hoisted_8 = { class: "p-col-12 p-md-6 p-lg-3" }
const _hoisted_9 = { for: "showDownloadButton" }
const _hoisted_10 = { class: "p-col-12 p-md-6 p-lg-3" }
const _hoisted_11 = { for: "showSelectMode" }
const _hoisted_12 = { class: "p-col-12 p-md-6 p-lg-3" }
const _hoisted_13 = { for: "showLayer" }
const _hoisted_14 = { class: "p-col-12 p-md-6 p-lg-3" }
const _hoisted_15 = { for: "showBaseLayer" }
const _hoisted_16 = { class: "p-col-12 p-md-6 p-lg-3" }
const _hoisted_17 = { for: "showMapConfig" }
const _hoisted_18 = { class: "p-col-12 p-md-6 p-lg-3" }
const _hoisted_19 = { for: "crossNavigationMultiselect" }
const _hoisted_20 = {
  key: 1,
  id: "informations-content",
  class: "kn-flex kn-relative kn-height-full"
}
const _hoisted_21 = {
  key: 0,
  for: "dsJoinCol",
  class: "p-error"
}
const _hoisted_22 = {
  key: 0,
  for: "label",
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Card = _resolveComponent("Card")
  const _component_Button = _resolveComponent("Button")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Column = _resolveComponent("Column")
  const _component_InputText = _resolveComponent("InputText")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-mb-3" }, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0 p-col-12" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.menu')), 1)
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_Checkbox, {
              id: "showRightConfigMenu",
              class: "p-mr-2",
              modelValue: _ctx.visibilityControls.showRightConfigMenu,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.visibilityControls.showRightConfigMenu = $event)),
              binary: true
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('workspace.gis.menu.showRightConfigMenu')), 1)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_Checkbox, {
              id: "showLegendButton",
              class: "p-mr-2",
              modelValue: _ctx.visibilityControls.showLegendButton,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visibilityControls.showLegendButton = $event)),
              binary: true
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('workspace.gis.menu.showLegendButton')), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Checkbox, {
              id: "showDistanceCalculator",
              class: "p-mr-2",
              modelValue: _ctx.visibilityControls.showDistanceCalculator,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.visibilityControls.showDistanceCalculator = $event)),
              binary: true
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('workspace.gis.menu.showDistanceCalculator')), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Checkbox, {
              id: "showDownloadButton",
              class: "p-mr-2",
              modelValue: _ctx.visibilityControls.showDownloadButton,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.visibilityControls.showDownloadButton = $event)),
              binary: true
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('workspace.gis.menu.showDownloadButton')), 1)
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_Checkbox, {
              id: "showSelectMode",
              class: "p-mr-2",
              modelValue: _ctx.visibilityControls.showSelectMode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.visibilityControls.showSelectMode = $event)),
              disabled: !_ctx.visibilityControls.showRightConfigMenu,
              binary: true
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('workspace.gis.menu.showSelectMode')), 1)
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_Checkbox, {
              id: "showLayer",
              class: "p-mr-2",
              modelValue: _ctx.visibilityControls.showLayer,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.visibilityControls.showLayer = $event)),
              disabled: !_ctx.visibilityControls.showRightConfigMenu,
              binary: true
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('workspace.gis.menu.showLayer')), 1)
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_Checkbox, {
              id: "showBaseLayer",
              class: "p-mr-2",
              modelValue: _ctx.visibilityControls.showBaseLayer,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.visibilityControls.showBaseLayer = $event)),
              disabled: !_ctx.visibilityControls.showRightConfigMenu,
              binary: true
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('workspace.gis.menu.showBaseLayer')), 1)
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_Checkbox, {
              id: "showMapConfig",
              class: "p-mr-2",
              modelValue: _ctx.visibilityControls.showMapConfig,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.visibilityControls.showMapConfig = $event)),
              disabled: !_ctx.visibilityControls.showRightConfigMenu,
              binary: true
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('workspace.gis.menu.showMapConfig')), 1)
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode(_component_Checkbox, {
              id: "crossNavigationMultiselect",
              class: "p-mr-2",
              modelValue: _ctx.crossNavigationMultiselect,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.crossNavigationMultiselect = $event)),
              disabled: _ctx.crossDisabled,
              binary: true
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('workspace.gis.menu.crossNavigationMultiselect')), 1)
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.documentData.selectedDataset.length > 0)
      ? (_openBlock(), _createBlock(_component_Toolbar, {
          key: 0,
          class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0 p-col-12"
        }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.filters')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "p-button-link",
              label: _ctx.$t('workspace.gis.dsj.addFilter'),
              onClick: _ctx.addFilterRow
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.documentData.selectedDataset.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_20, [
          _createVNode("div", {
            style: _ctx.styleDescriptor.style.absoluteScroll
          }, [
            _createVNode(_component_Card, null, {
              content: _withCtx(() => [
                _createVNode(_component_DataTable, {
                  class: "p-datatable-sm kn-table georef-step1-table",
                  value: _ctx.documentDataProp.filters,
                  dataKey: "id",
                  responsiveLayout: "scroll",
                  breakpoint: "600px"
                }, {
                  empty: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('workspace.gis.dnl.emptyInfo')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "name",
                      header: _ctx.$t('workspace.gis.dsj.dsJoinCol'),
                      sortable: true
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_Dropdown, {
                          id: "dsJoinCol",
                          class: ["kn-material-input kn-width-full", { 'p-invalid': slotProps.data.name == null }],
                          modelValue: slotProps.data.name,
                          "onUpdate:modelValue": ($event: any) => (slotProps.data.name = $event),
                          options: _ctx.documentDataProp.datasetJoinColumns,
                          optionLabel: "id",
                          optionValue: "id"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "class"]),
                        (slotProps.data.name == null)
                          ? (_openBlock(), _createBlock("small", _hoisted_21, _toDisplayString(_ctx.$t('workspace.gis.fieldRequired')) + " *", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, {
                      field: "label",
                      header: _ctx.$t('workspace.gis.dsj.lyrJoinCol'),
                      sortable: true
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_InputText, {
                          id: "label",
                          class: ["kn-material-input kn-width-full", { 'p-invalid': slotProps.data.label == null || slotProps.data.label == '' }],
                          modelValue: slotProps.data.label,
                          "onUpdate:modelValue": ($event: any) => (slotProps.data.label = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                        (slotProps.data.label == null || slotProps.data.label == '')
                          ? (_openBlock(), _createBlock("small", _hoisted_22, _toDisplayString(_ctx.$t('workspace.gis.fieldRequired')) + " *", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, {
                      style: _ctx.styleDescriptor.style.trashColumn
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_Button, {
                          icon: "pi pi-trash",
                          class: "p-button-link",
                          onClick: ($event: any) => (_ctx.deleteFilterRow(slotProps))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}